import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M4 9.36h24v1.3H4zM4 13.63h24v1.3H4zM4 17.9h24v1.3H4zM4 22.17h14.02v1.3H4z' })
));